import {React, Component} from "react";
import {
    Typography,
    Button,
    Grid,
    Box,
    Card,
    CardContent,
    CardMedia,
    
  } from '@mui/material';
  import SkipNextIcon from '@mui/icons-material/SkipNext';
import { Link as RouterLink } from 'react-router-dom';
import Nav_bar from './Nav'
import Footer from './footer'
class pricing extends Component{
    render()
    {
        return(
            <>
            <Nav_bar/>
            <Box sx={{ width: '100%'}}>
      <Card
              sx={{
                backgroundImage:'url(https://qrcodechimp.s3.amazonaws.com/blog/wp-content/uploads/2020/03/free-online-qr-code-generator.jpg)',
                backgroundRepeat:'no-repeat',
                backgroundSize:'100% 100%',
                boxShadow: '0px 0px 20px rgba(0,0,0,0.5)',
                height: { xs: '840px', md: '480px' },
                width: '100%',
                margin: 0,
                padding: 0,
              }}
            >
    </Card>
      </Box>
    <Box sx={{ width: '100%' }}>
        <Grid container alignItems="center" style={{ margin: 0, padding: 0 }}>
          <Grid item xs={12}>
            <Card
              sx={{
                background: '#16212F',
                boxShadow: '0px 0px 20px rgba(0,0,0,0.5)',
                height: { xs: '840px', md: '520px' },
                width: '100%',
                margin: 0,
                padding: 0,
                color:'white',
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '25px',
                    width: '100%',
                    marginTop:'30px'
                  }}
                >
                  
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '15px',
                      maxWidth: '600px',
                      width: '100%',
                    }}
                  >
                    <Typography variant="h3" component="div" sx={{ fontFamily: 'serif', fontWeight: 'bold' }}>
                            Premium And Free Plan Of MY APP
                    </Typography>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ fontFamily: 'initial', color:'whitesmoke',fontWeight:'bold',fontSize: '18px' }}
                    >
                     Learn a lot of interesting and useful things about creating and using QR codes.
                    </Typography>
                  </Box>

                  <CardMedia
                    component="img"
                    alt="QR code scanner"
                    src="https://img.freepik.com/premium-vector/contactless-payment-concept-smartphone-with-atm-terminal-scanning-qr-code-digital-transfers_118813-18394.jpg?ga=GA1.1.1039325513.1697432724&semt=ais_hybrid"
                    sx={{
                      height: { xs: '350px', md: '450px' },
                      width: { xs: '100%', md: '100%' },
                      borderRadius: '15px',
                      marginBottom: { xs: '20px', md: '0' },
                    }}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
     
            <Footer/>
            </>
        )
    }
}
export default pricing